import green from "@material-ui/core/colors/green";

export default theme => ({
  root: {
    maxWidth: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3)
  },
  rootGray: {
    maxWidth: "100%",
    backgroundColor: "grey",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3)
  },
  title: {
    fontSize: "18px",
    lineHeight: "21px",
    textAlign: "center",
    marginTop: theme.spacing(2)
  },
  cardTasks: {
    marginTop: "5px",
    textAlign: "center"
  },

  card: {
    display: "flex",
    width: "350px",
    "&:hover": {
      boxShadow:
        "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)",
      cursor: "pointer"
    }
  },
  cardEnabled: {
    display: "flex",

    flexDirection: "row",
    width: "350px",
    backgroundColor: theme.palette.background.light,
    "&:hover": {
      boxShadow:
        "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)",
      cursor: "pointer"
    }
  },

  cardHeader: {
    padding: theme.spacing(1.5, 1.5)
  },

  cardContainer: {
    display: "flex",
    flexDirection: "row"
  },

  cardImage: {
    maxWidth: "80px",
    maxHeight: "80px",
    // width: "64px",
    // height: "64px",
    display: "block",
    margin: "auto"
  },
  badgeSuccess: {
    backgroundColor: green[400],
    right: "auto"
    // right: "auto"
  },
  moreButton: {
    right: 0,
    padding: theme.spacing(1)
  },

  badgeError: {
    backgroundColor: theme.palette.error.light,
    right: "auto"
  },
  details: {
    display: "flex"
    // flexDirection: "column"
  },
  content: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    borderLeft: "1px solid #E2E2E2"
  },
  connectorTitle: {
    textTransform: "uppercase",
    letterSpacing: "0.3px"
  },
  connectorTasks: {
    textTransform: "uppercase",
    marginTop: theme.spacing(0.5),
    color: theme.palette.common.muted

    // fontSize: ''
  },
  cover: {
    width: 96,
    height: 96,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1)
  },
  linkUnderline: {
    textDecoration: "none"
  },

  grower: {
    flexGrow: 1
  }
});
